import { render, staticRenderFns } from "./ManualAction.vue?vue&type=template&id=63e0ad5a&scoped=true"
import script from "./ManualAction.vue?vue&type=script&lang=ts"
export * from "./ManualAction.vue?vue&type=script&lang=ts"
import style0 from "./ManualAction.vue?vue&type=style&index=0&id=63e0ad5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0ad5a",
  null
  
)

export default component.exports